export default __webpack_public_path__ + "static/media/lamp3.150107c5.jpg";